// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"9df974aa","617":"b1df8ba0"}[chunkId] + ".chunk.js";
};